import React, { useEffect} from "react";
import { useImmer } from "use-immer";
import { Card } from "react-bootstrap"
import "./NotificationCard.css"
import CardHeader from "react-bootstrap/esm/CardHeader";
const NotificationCard = ({ content, createdDate}) => {


// This Function for create content
    var initial_state = {
        finalDate: "",
        finalRuleName: "",
        EventDescription: "",
        DocTitle: ""
    };
    
    const [getContent, setContent] = useImmer(initial_state);
    
    
    function contentCreater(conten) {

        var finalDate = "";
        var finalRule = "";
        var finalDesc = "";
        var finalTitle = "";
    
        var Rul = conten.split("Rule Name:");
        if (Rul.length > 1) {
            var Rule2 = Rul[1].split("Event Description:");
                finalRule = Rule2[0].trim();
        }
    
        var Des = conten.split("Event Description:");

        if (Des.length > 1) {
            var Desc2 = Des[1].split("Document Title:");
                finalDesc = Desc2[0].trim();
        }
    
        var Titl = conten.split("Document Title:");
    
        if (Titl.length > 1) {
            var Title2 = Titl[1].split("Created Date:");
                finalTitle = Title2[0].trim();
        }
    
        var Dat = conten.split("Created Date:");
    
        if (Dat.length > 1) {
            var Date2 = Dat[1].split("Notification Frequency:");
                finalDate = Date2[0].trim();
        }
    
        setContent((draft) => {
            draft.finalDate = finalDate;
            draft.finalRuleName = finalRule;
            draft.EventDescription = finalDesc;
            draft.DocTitle = finalTitle;
        });
    };



useEffect (()=>{
  contentCreater(content)
},[content])
  return (
    <React.Fragment>
    <Card>
      <Card.Body>
        <Card.Text style={{ fontSize: '13px' }}>
          <div>
            <strong>Date:</strong> {getContent.finalDate || createdDate || "-"}
          </div>
          <div>
          <strong>Rule Name:</strong> {getContent.finalRuleName}
          </div>
          <div>
          <strong>Description: </strong>{getContent.EventDescription}
          </div>
          <div>
          <strong>Document Title: </strong>{getContent.DocTitle}
          </div>
        </Card.Text>
      </Card.Body>
    </Card>
    </React.Fragment>
  )
};
export default NotificationCard;